import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

const myCustomLightTheme = {
  dark: false,
  colors: {
    primary: '#007eff',
    secondary: '#e1e4e8',
    accent: '#007eff',
    error: '#ff634d',
    warning: '#E65100',
    info: '#0f51b2',
    success: '#44d7ab',
    colorText: '#3f4146',
    colorText2: '#262a31',
    paleblue: '#e1e4e8',
    palegrey: '#f5f7f1',
    palegreytwo: '#f1f2f4',
    dusk: '#4e5d78',
    yellowishOrange: '#ff9e1a',
    butterscotch: '#ffb34b',
    orangish: '#ff834d',
    steel: '#82868e',
    lightBlueGrey: '#c3ccdc',
    lightGreyBlue: '#b0b7c3',
    red: '#F44336',
    white: '#FFFFFF',
    green: '#4CAF50',
  },
};

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme,
    },
  },
});
